import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import { OPEN_BUSINESS_ACCOUNT_PAGE, OFFER } from '../../utils/constants';
import { dataCaptureSelectors, getOffers } from '../../store/dataCapture';
import OpenBusinessAccountPage from '../openBusinessAccountSection/OpenBusinessAccountPage';
import ALtBusinessAccountPage from '../altBusinessAccountSection/AltBusinessAccountPage';
import { offerSelector, submitOffer } from '../../infrastructure/offers';
import {
  WEB_BUSINESS_TERMS_CONDITIONS,
  WEB_BUSINESS_TARIFF_GUIDE,
  WEB_FSCS_INFORMATION
} from '../../utils/constants';
const TASK_URI = 'task_uri';
class OfferSection extends Component {
  constructor(props) {
    super(props);
    this.onConfirmationCheckboxChange = this.onConfirmationCheckboxChange.bind(this);
    this.state = { isTermsChecked: false };
  }

  componentDidMount() {
    if (this.props.taskUri !== OFFER) {
      this.props.getOffers();
    }
    this.forceUpdate();
  }
  onConfirmationCheckboxChange(value) {
    this.setState({ isTermsChecked: value });
  }

  render() {
    const {
      bankId,
      brandId,
      isBasicBusinessAccount,
      getBusinessData,
      isCurrentAccount,
      submitOffer,
      dailyLimit,
      transactionLimit,
      termsConditionsRef,
      tariffGuideRef,
      fscsRef
    } = this.props;

    return isBasicBusinessAccount === undefined ? (
      <span />
    ) : isBasicBusinessAccount ? (
      <OpenBusinessAccountPage
        brandId={brandId}
        bankId={bankId}
        saveOpenBusinessAccountForm={submitOffer}
        getBusinessData={getBusinessData}
        isCurrentAccount={isCurrentAccount}
        onConfirmationCheckboxChange={this.onConfirmationCheckboxChange}
        isTermsChecked={this.state.isTermsChecked}
        dailyLimit={dailyLimit}
        transactionLimit={transactionLimit}
      />
    ) : (
      <ALtBusinessAccountPage
        brandId={brandId}
        bankId={bankId}
        saveAltBusinessAccountForm={submitOffer}
        getBusinessData={getBusinessData}
        onConfirmationCheckboxChange={this.onConfirmationCheckboxChange}
        isTermsChecked={this.state.isTermsChecked}
        dailyLimit={dailyLimit}
        transactionLimit={transactionLimit}
        termsConditionsRef={termsConditionsRef}
        tariffGuideRef={tariffGuideRef}
        fscsRef={fscsRef}
      />
    );
  }
}

OfferSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  submitOffer: PropTypes.func.isRequired
};

const actionCreators = {
  getOffers,
  submitOffer
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, OPEN_BUSINESS_ACCOUNT_PAGE),
  isBasicBusinessAccount: offerSelector.isBasicBusinessAccount(state),
  isCurrentAccount: offerSelector.isBusinessCurrentAccount(state),
  taskUri: selectors.getSingleEntry(state, TASK_URI),
  dailyLimit: offerSelector.getDailyLimit(state),
  transactionLimit: offerSelector.getTransactionLimit(state),
  termsConditionsRef: selectors.getPdfByWebReference(state, WEB_BUSINESS_TERMS_CONDITIONS),
  tariffGuideRef: selectors.getPdfByWebReference(state, WEB_BUSINESS_TARIFF_GUIDE),
  fscsRef: selectors.getPdfByWebReference(state, WEB_FSCS_INFORMATION)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OfferSection);
